import { CapacitorHttp } from '@capacitor/core';
import { getApiUrl, isNativeApp } from './platform';
import { supabase } from './supabase';

const parseBody = (raw) => {
  if (typeof raw === 'string') {
    try { return parseBody(JSON.parse(raw)); } catch { return null; }
  }
  return raw && typeof raw === 'object' && !Array.isArray(raw) ? raw : null;
};

const responseError = (status, url, body) => {
  const endpoint = new URL(url, window.location.origin);
  const source = `${endpoint.hostname}${endpoint.pathname}`;
  let message = typeof body?.error === 'string' ? body.error : '';
  if (!message) {
    if (status === 404) message = 'Deze API-route is niet beschikbaar op de ingestelde server. Controleer de deployment.';
    else if ([401, 403].includes(status)) message = 'De server weigert toegang. Controleer je login en eventuele Vercel Deployment Protection.';
    else if (status >= 200 && status < 300) message = 'De server gaf geen geldig API-antwoord. Mogelijk wordt een website of Vercel-inlogpagina geladen.';
    else message = 'De serveraanvraag is mislukt. Controleer de deployment en serverlogs.';
  }
  const error = new Error(`${message} (HTTP ${status}; ${source})`);
  error.status = status;
  error.apiPath = endpoint.pathname;
  error.apiHost = endpoint.hostname;
  return error;
};

export const apiRequest = async (path, options = {}) => {
  const { data } = await supabase.auth.getSession();
  const headers = {
    'Content-Type': 'application/json',
    ...(data.session?.access_token ? { Authorization: `Bearer ${data.session.access_token}` } : {}),
    ...(options.headers || {}),
  };
  const url = getApiUrl(path);
  if (isNativeApp()) {
    // Only our server API uses native HTTP; preserve existing bearer authentication.
    const response = await CapacitorHttp.request({
      url,
      method: options.method || 'GET',
      headers,
      ...(options.body ? { data: JSON.parse(options.body) } : {}),
      connectTimeout: 15000,
      readTimeout: 30000,
    });
    const body = parseBody(response.data);
    if (response.status < 200 || response.status >= 300 || !body) throw responseError(response.status, url, body);
    return body;
  }
  const response = await fetch(url, { ...options, headers });
  const body = parseBody(await response.json().catch(() => null));
  if (!response.ok || !body) throw responseError(response.status, url, body);
  return body;
};
